import { Component, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-pharmacy-address',
  imports: [ReactiveFormsModule],
  templateUrl: './pharmacy-address.html',
  styleUrl: './pharmacy-address.scss',
})
export class PharmacyAddress {
  pharmacyForm = input.required<FormGroup>();
}
